import axios from 'axios';

const server = process.env.REACT_APP_SERVER_URL;

export interface Alicuota {
  id_actividad_economica_contribuyente: number;
  actividad_economica: string;
  numero_referencia: string;
  aplicable_desde: string;
  id_contribuyente: number;
  razon_social: string;
  rim: string;
}


export const getAlicuotasByRim = async (rim: string) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${server}/utilidades/alicuota/load-alicuotas`, {
    params: { rim },
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};


export const updateAlicuota = async (data: {
  id_actividad: number;
  numero_referencia: string;
  aplicable_desde: string;
}) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${server}/utilidades/alicuota/actualizar-alicuota`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};


export const deleteAlicuota = async (data: {
  rim: string;
  id_actividad: number;
}) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${server}/utilidades/alicuota/eliminar-alicuota`, {
    data,
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
